import Lenis from '@studio-freight/lenis';

export const lenis= () => {
    const lenisEasing = (x) => {
        return Math.sin((x * Math.PI) / 2);
    };
    const lenis = new Lenis({
        duration: 1.2, // Duration of the scrolling
        easing: lenisEasing,
    });
    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
}
